// extracted by mini-css-extract-plugin
export default {"box":"MessageGrid_box__s78Np","container":"MessageGrid_container__b4cVQ","btn":"MessageGrid_btn__9Fm-k","time":"MessageGrid_time__JJr9U"};